export const ROUTE_PATH = '/bonus-transaction-level-history';

export const FEATURE_NAME = 'bonusTransactionLevelHistoryPage';
